interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg shadow-cyan-500/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center space-x-3 cursor-pointer group"
          >
            <img
              src="https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/43884c505bd2c9515d324bd839f9d0c8.jpeg"
              alt="Joysticks, Pixels & Pour"
              className="h-12 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </button>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-sm font-medium text-gray-300 hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('games')}
              className="text-sm font-medium text-gray-300 hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
            >
              Games
            </button>
            <button
              onClick={() => scrollToSection('drinks')}
              className="text-sm font-medium text-gray-300 hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('events')}
              className="text-sm font-medium text-gray-300 hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
            >
              Events
            </button>
            <button
              onClick={() => scrollToSection('parties')}
              className="text-sm font-medium text-gray-300 hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
            >
              Parties
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white text-sm font-bold rounded-lg hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </button>
          </div>

          <button className="md:hidden text-cyan-400 cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
